import type { CityConfig } from "../city-template/types";

export const williamsburgVaConfig: CityConfig = {
  city: "Williamsburg",
  state: "Virginia",
  stateAbbr: "VA",
  slug: "williamsburg-va",
  route: "/williamsburg-va",
  title: "Emergency Passport Williamsburg, VA — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency and expedited passport services in Williamsburg, VA — as fast as 24 hours. Same-day courier processing available. A+ BBB rated, registered State Dept. courier serving Williamsburg, James City County, and the Historic Triangle. Get your passport fast!",
  h1: "Emergency & Expedited Passport Services in Williamsburg, VA",
  heroSubtitle: "Passport expired before your trip? Traveling from the Historic Triangle, James City County, or York County? We help Williamsburg travelers get expedited passports as quickly as 24 hours. A+ BBB rated. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Colonial%20Williamsburg%20Virginia%20historic%20district%20with%20restored%2018th%20century%20colonial%20buildings%2C%20Duke%20of%20Gloucester%20Street%20with%20brick%20sidewalks%20and%20wooden%20colonial%20houses%2C%20warm%20golden%20hour%20light%20with%20autumn%20foliage%2C%20the%20Governors%20Palace%20grounds%20in%20the%20background%2C%20professional%20photography%20showcasing%20the%20Historic%20Triangle%20with%20rich%20colonial-era%20atmosphere%20and%20heritage%20tourism%20charm%2C%20no%20people%20visible%2C%20scenic%20American%20historical%20landscape%20with%20well-preserved%20architecture%20and%20manicured%20gardens&width=1800&height=700&seq=williamsburg-va-hero-001&orientation=landscape",
  heroImageAlt: "Colonial Williamsburg historic district with 18th century colonial buildings and Duke of Gloucester Street",
  geoPosition: "37.2707;-76.7075",
  geoPlacename: "Williamsburg, Virginia",
  lastModified: "2026-07-21",
  regionalAgency: {
    name: "Washington Passport Agency",
    address: "600 19th Street NW, Washington, DC 20006",
    distance: "Located in downtown Washington, DC — approximately 150 miles north of Williamsburg via I-95",
  },
  nearbyCitiesZips: [
    { name: "Williamsburg", zips: "23185, 23186, 23187, 23188" },
    { name: "Jamestown", zips: "23081" },
    { name: "Yorktown", zips: "23690, 23691, 23692, 23693" },
    { name: "Newport News", zips: "23601, 23602, 23603, 23605, 23606, 23607, 23608" },
    { name: "Hampton", zips: "23630, 23651, 23661, 23663, 23664, 23665, 23666, 23667, 23668, 23669, 23681" },
    { name: "Poquoson", zips: "23662" },
    { name: "Toano", zips: "23168" },
    { name: "Lightfoot", zips: "23188" },
    { name: "Norge", zips: "23127" },
    { name: "Richmond", zips: "23218, 23219, 23220, 23221, 23222, 23223, 23224, 23225, 23226, 23227, 23228, 23229, 23230, 23231, 23233, 23234, 23235, 23236, 23237, 23238, 23242" },
    { name: "Virginia Beach", zips: "23450, 23451, 23452, 23453, 23454, 23455, 23456, 23457, 23458, 23459, 23460, 23461, 23462, 23463, 23464, 23465, 23466, 23467, 23468, 23471, 23479" },
    { name: "Norfolk", zips: "23501, 23502, 23503, 23504, 23505, 23506, 23507, 23508, 23509, 23510, 23511, 23513, 23514, 23515, 23517, 23518, 23519, 23520, 23521, 23523, 23529, 23541, 23551" },
    { name: "Fredericksburg", zips: "22401, 22402, 22403, 22404, 22405, 22406, 22407, 22408" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier submission for urgent travel departures from the Historic Triangle" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-user-line", title: "Dedicated Agent", desc: "A real person assigned to your case from start to finish" },
    { icon: "ri-map-pin-2-line", title: "Historic Triangle Hub", desc: "Serving Williamsburg, Jamestown, Yorktown, James City, and York County" },
  ],
  internalLinks: [
    { name: "Virginia state passport services", route: "/virginia" },
    { name: "Newport News VA passport services", route: "/newport-news-va" },
    { name: "Norfolk VA passport services", route: "/norfolk-va" },
    { name: "Fredericksburg VA passport services", route: "/fredericksburg-va" },
  ],
  fpcOfficeNote: "Fast Passport Center serves Williamsburg remotely via secure courier. We do not have a walk-in office in Williamsburg — our registered couriers hand-deliver your documents directly to U.S. Department of State processing facilities. This is how we achieve 24–48 hour turnaround for Williamsburg and Historic Triangle travelers.",
  fpcOfficeAddress: "7272 Wisconsin Ave, Bethesda, Maryland 20814",
  fpcOfficeDistance: "Serving all of Williamsburg and the Historic Triangle including Jamestown, Yorktown, James City County, York County, and the greater Virginia Peninsula",
  serviceAreaIntro: "From the cobblestone streets of Colonial Williamsburg to the quiet suburbs of James City County, from the College of William & Mary campus to the battlefields of Yorktown, from the Jamestown Settlement to the modern developments of Toano and Lightfoot — Fast Passport Center serves every corner of Williamsburg and the Historic Triangle. We regularly help travelers from Newport News, Hampton, Yorktown, and Poquoson get their passports fast.",
  nearbyCitiesIntro: "We serve all Williamsburg neighborhoods and the Historic Triangle including Jamestown, Yorktown, James City County, York County, Toano, Lightfoot, and the greater Virginia Peninsula region.",
  howItWorksIntro: "Most Williamsburg travelers complete everything online and ship documents overnight. No need to travel to the Washington regional agency or wait in long government lines.",
  mistakesIntro: "Williamsburg travelers often face the temptation to travel to the Washington regional passport agency. Here are the most common mistakes that cause delays.",
  testimonialsIntro: "Williamsburg and Historic Triangle travelers trust us when their departure is days away. Here is what some of them have to say.",
  faqIntro: "Have questions about expedited passports in Williamsburg? Here are the most common ones we hear from Historic Triangle travelers.",
  statePageRoute: "/states/virginia",
  statePageName: "Virginia",
  dmvWebsite: "https://www.dmv.virginia.gov",
  dmvLabel: "Virginia DMV — Official Website",
  vitalRecordsIcon: "ri-heart-pulse-line",
  vitalRecordsLinks: [
    { icon: "ri-user-smile-line", label: "Birth Certificate", desc: "Request certified birth certificates from Virginia Department of Health Vital Records. Online, mail, or in-person options available for Williamsburg and James City County residents.", url: "https://www.vdh.virginia.gov/vital-records/" },
    { icon: "ri-file-list-2-line", label: "Death Certificate", desc: "Obtain certified death certificates through Virginia Department of Health Vital Records. Required for estate, insurance, and legal matters.", url: "https://www.vdh.virginia.gov/vital-records/" },
    { icon: "ri-hearts-line", label: "Marriage Certificate", desc: "Request marriage license records from the Williamsburg/James City County Circuit Court Clerk. Certified copies available for name changes and legal purposes.", url: "https://www.williamsburgva.gov/" },
    { icon: "ri-file-copy-line", label: "Divorce Decree", desc: "Obtain certified divorce records through the Williamsburg/James City County Circuit Court Clerk. Required for name change passport corrections.", url: "https://www.williamsburgva.gov/" },
  ],
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Predictable turnaround",
        "Ideal for upcoming trips",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Faster than self-service",
        "Good for planned travel",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: [
        "No courier access — standard mail only",
        "Workload & wait times shift with shutdowns",
        "In-person clerk appointment required",
        "No document review — errors cause rejection",
        "No dedicated agent — you are on your own",
        "Updates only by physical mail letter",
        "No phone or email contact for your case",
        "Can't upgrade speed after submission",
        "Not suitable if travel is within 10 weeks",
      ],
      highlight: false,
      muted: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: [
        "Appointment required — no walk-ins allowed",
        "Life-or-death emergencies only",
        "Bereavement or medical crisis",
        "Expect to wait all day or return next day",
      ],
      highlight: false,
      emergency: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For travelers with immediate departure needs — as fast as 24 hours for urgent Williamsburg international flights and last-minute travel.",
      bullets: ["24–48 hour turnaround available", "Registered courier hand-delivery", "Flight verification support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for adults with a passport issued within the last 15 years at age 16 or older.",
      bullets: ["No clerk visit required for most", "Mail-in or courier options", "Lost passport replacement available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport",
      description: "First-time passport application guidance with acceptance clerk appointment support.",
      bullets: ["Acceptance facility locator", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Passport replacement with DS-64 form guidance and police report documentation.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement options"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 with parental consent and acceptance clerk support.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change",
      description: "Passport correction and name change service after marriage, divorce, or legal changes.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
    { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
    { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
    { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
    { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
    { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
  ],
  testimonials: [
    {
      name: "Elizabeth C.",
      location: "Williamsburg, VA",
      rating: 5,
      text: "I live near Colonial Williamsburg and needed an emergency passport for a Paris vacation with 4 days notice. Fast Passport Center had my renewal in 3 days. I shipped from the UPS on Richmond Road and it was completely seamless. No need to leave the Historic Triangle for passport services.",
      service: "Emergency Passport",
    },
    {
      name: "Richard M.",
      location: "James City County, VA",
      rating: 5,
      text: "As a James City County resident, I was worried about finding expedited passport services close to home. Fast Passport Center made it incredibly easy. Everything was done online, and my renewal was back in 5 days. The convenience for Historic Triangle families is unbeatable.",
      service: "Passport Renewal",
    },
    {
      name: "Patricia G.",
      location: "Yorktown, VA",
      rating: 5,
      text: "First passports for my twin boys before a cruise to the Bahamas. Fast Passport Center handled all the parental consent requirements flawlessly and had both passports in 6 days. For Yorktown families, this is the best expedited passport service around.",
      service: "Child Passport",
    },
    {
      name: "Steven B.",
      location: "Williamsburg, VA",
      rating: 5,
      text: "Lost my passport 3 days before a business trip to Frankfurt. I was in absolute panic. Fast Passport Center had a replacement in my hands in 48 hours. They saved my career and my business trip. Williamsburg professionals need this service.",
      service: "Lost Passport",
    },
  ],
  facilities: [
    {
      id: "williamsburg-va-1",
      name: "Williamsburg Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "Street address pending USPS listing",
      city: "Williamsburg",
      state: "VA",
      zip: "23185",
      phone: "(757) 229-2181",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Downtown Williamsburg",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary Williamsburg facility. Full passport services with appointment. Call ahead to confirm.",
      icon: "ri-mail-line",
    },
    {
      id: "williamsburg-va-2",
      name: "Newport News Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "Street address pending USPS listing",
      city: "Newport News",
      state: "VA",
      zip: "23601",
      phone: "(757) 247-3211",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Newport News, southeast of Williamsburg",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves the Virginia Peninsula and Hampton Roads region. Full passport services with appointment.",
      icon: "ri-mail-line",
    },
    {
      id: "williamsburg-va-3",
      name: "Yorktown Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "Street address pending USPS listing",
      city: "Yorktown",
      state: "VA",
      zip: "23690",
      phone: "(757) 898-3834",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Yorktown, northwest of Williamsburg",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Yorktown and York County. Full passport services with appointment.",
      icon: "ri-mail-line",
    },
    {
      id: "williamsburg-va-4",
      name: "Hampton Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "Street address pending USPS listing",
      city: "Hampton",
      state: "VA",
      zip: "23661",
      phone: "(757) 727-0354",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Hampton, east of Williamsburg",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Hampton and the Virginia Peninsula. Full passport services with appointment.",
      icon: "ri-mail-line",
    },
    {
      id: "williamsburg-va-5",
      name: "James City County Clerk",
      type: "County Clerk",
      address: "1017 Kings Way",
      city: "Williamsburg",
      state: "VA",
      zip: "23185",
      phone: "(757) 253-6701",
      hours: "Mon–Fri: 8:30 AM – 4:30 PM",
      distance: "Williamsburg, James City County",
      website: "https://jamescitycountyva.gov",
      websiteLabel: "James City County",
      notes: "Provides vital records and birth certificates. Not a passport acceptance facility but useful for document collection.",
      icon: "ri-building-2-line",
    },
    {
      id: "williamsburg-va-6",
      name: "College of William & Mary",
      type: "Campus Resource",
      address: "200 Stadium Dr",
      city: "Williamsburg",
      state: "VA",
      zip: "23185",
      phone: "(757) 221-4000",
      hours: "Mon–Fri: 8:00 AM – 5:00 PM",
      distance: "Williamsburg, near the historic district",
      website: "https://www.wm.edu",
      websiteLabel: "W&M Official Website",
      notes: "Not a passport acceptance facility, but helpful for students and international program participants. Check with student services.",
      icon: "ri-building-2-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, limited slots", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — drive to downtown DC", fpc: "No — ship from home or office" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "Guaranteed Timing", agency: "No — subject to availability", fpc: "Yes — contractual turnaround times" },
    { feature: "Military & Government", agency: "No special handling", fpc: "Yes — priority for military and government travelers" },
    { feature: "Multi-Application Households", agency: "One slot per application", fpc: "Yes — family batch processing supported" },
  ],
  mistakes: [
    {
      icon: "ri-image-line",
      title: "Wrong Photo Size or Background",
      description: "Williamsburg photo shops often use generic sizes. Passport photos must be exactly 2x2 inches with a white or off-white background.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form",
      description: "Missing signatures or using the wrong form type are the #1 reasons for rejection at Historic Triangle acceptance facilities.",
    },
    {
      icon: "ri-money-dollar-circle-line",
      title: "Wrong Payment Amount",
      description: "Fees change frequently. Many Williamsburg applicants show up with incorrect payment and have to reschedule their appointment.",
    },
    {
      icon: "ri-calendar-close-line",
      title: "No Proof of Travel",
      description: "Without flight confirmation or travel itinerary, the Washington DC regional agency will turn you away for emergency appointments.",
    },
    {
      icon: "ri-parent-line",
      title: "Missing Parental Consent",
      description: "For minors, both parents must appear or submit notarized consent. This trips up many Williamsburg families at the clerk.",
    },
    {
      icon: "ri-time-line",
      title: "Waiting Too Long to Start",
      description: "Williamsburg travelers often assume standard processing will be fine. It takes 8-11 weeks. Start expedited at least 3 weeks before travel.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS location in Williamsburg or nearby." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy before hand-delivering to the State Department." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Your passport is processed at a U.S. Department of State facility using our registered courier slots." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Williamsburg address — trackable every step of the way." },
  ],
  faqs: [
    { q: "Can I get an emergency passport in Williamsburg before my international trip?", a: "Yes. Fast Passport Center provides emergency passport services in Williamsburg for travelers with urgent international departures. Our registered couriers hand-deliver your documents directly to U.S. Department of State facilities, achieving 24-48 hour turnaround — perfect for last-minute trips from the Historic Triangle and James City County." },
    { q: "How fast can I renew my passport in Williamsburg?", a: "Fast Passport Center offers fast passport renewal in Williamsburg in as little as 24-48 hours through our emergency courier service. For less urgent travel, our 3-5 day expedited option provides the best value. Both options include full document review and a dedicated agent." },
    { q: "What is the closest passport agency to Williamsburg?", a: "The nearest regional passport agency to Williamsburg is the Washington Passport Agency, located approximately 150 miles north in downtown Washington, DC. For urgent processing without the long drive, Fast Passport Center's registered courier service achieves 24-48 hour turnaround from Williamsburg." },
    { q: "Can I get a same-day passport appointment near Williamsburg?", a: "Same-day passport appointments are only available at the Washington Regional Passport Agency for documented life-or-death emergencies. For all other urgent travel, Fast Passport Center's 24-48 hour emergency courier processing is the fastest guaranteed option for Williamsburg residents." },
    { q: "Can I expedite a child passport in Williamsburg?", a: "Yes. Fast Passport Center expedites child passports in Williamsburg for minors under 16. Both parents must appear or submit notarized consent, along with the child's birth certificate and both parents' IDs. We walk Williamsburg and James City County families through the entire process." },
    { q: "What should I do if I lost my passport before a trip?", a: "If you lost your passport before a trip, contact Fast Passport Center immediately. We provide lost passport replacement services in Williamsburg with DS-64 form guidance and identity verification support. Our emergency courier service can get your replacement passport in 24-48 hours." },
    { q: "How fast can I get a passport in Williamsburg?", a: "With Fast Passport Center's emergency courier service, Williamsburg travelers can receive their passport in as little as 24-48 hours. Our registered couriers hand-deliver your documents directly to U.S. Department of State processing facilities, bypassing standard mail delays." },
    { q: "Do I need to drive to the Washington Passport Agency?", a: "No. With Fast Passport Center, you complete everything online and ship your documents overnight. Our couriers handle the in-person delivery to State Department facilities. You only need to visit a local acceptance clerk if you're a first-time applicant or need a name change." },
    { q: "Where are the closest passport acceptance facilities near Williamsburg?", a: "Popular options include the Williamsburg Main Post Office (23185), Newport News Post Office (23601), Yorktown Post Office (23690), and Hampton Post Office (23661). All require appointments. We help you find the most convenient location and schedule your visit." },
    { q: "What if I live in Jamestown or Yorktown?", a: "We serve the entire Historic Triangle including Jamestown, Yorktown, and the surrounding area. Our overnight shipping labels work from any UPS location, so your location doesn't affect processing speed." },
    { q: "How much does expedited passport service cost in Williamsburg?", a: "Government fees are fixed: $130 for a passport book (adult) plus a $60 expedite fee. Fast Passport Center's service fees vary by processing speed — emergency 24-48 hour processing, 3-5 day expedited, or standard options. Contact us for a personalized quote." },
  ],
  photoLocations: [
    { name: "CVS Pharmacy — Williamsburg", address: "2020 Richmond Rd, Williamsburg, VA 23185", hours: "Mon-Sun: 8AM-10PM" },
    { name: "Walgreens — Williamsburg", address: "4900 Monticello Ave, Williamsburg, VA 23188", hours: "Mon-Sun: 7AM-11PM" },
    { name: "FedEx Office — Williamsburg", address: "5520 Williamsburg Market Sq, Williamsburg, VA 23188", hours: "Mon-Fri: 7AM-9PM, Sat: 8AM-6PM" },
    { name: "CVS Pharmacy — Newport News", address: "700 J. Clyde Morris Blvd, Newport News, VA 23601", hours: "Mon-Sun: 8AM-10PM" },
    { name: "Walgreens — Hampton", address: "2216 W Mercury Blvd, Hampton, VA 23666", hours: "Mon-Sun: 7AM-11PM" },
    { name: "CVS Pharmacy — Yorktown", address: "1014 Waller Mill Rd, Yorktown, VA 23690", hours: "Mon-Sun: 8AM-10PM" },
  ],
  dmvLocations: [
    {
      name: "Virginia DMV — Williamsburg",
      address: "7480 Richmond Rd, Williamsburg, VA 23188",
      hours: "Mon-Fri: 8AM-5PM",
      note: "Driver's license and REAL ID services. Appointment recommended.",
      featured: true,
    },
    {
      name: "Virginia DMV — Newport News",
      address: "12750 Jefferson Ave, Newport News, VA 23606",
      hours: "Mon-Fri: 8AM-5PM",
      note: "REAL ID and passport-related ID services. Appointment strongly recommended.",
      featured: false,
    },
    {
      name: "Virginia DMV — Hampton",
      address: "8109 W Mercury Blvd, Hampton, VA 23666",
      hours: "Mon-Fri: 8AM-5PM",
      note: "Serves Hampton and the Virginia Peninsula. REAL ID available.",
      featured: false,
    },
  ],
  airports: [
    {
      code: "PHF",
      name: "Newport News/Williamsburg International Airport",
      distance: "Approximately 20 miles southeast of Williamsburg",
      address: "900 Bland Blvd, Newport News, VA 23602",
      note: "The closest airport to Williamsburg. Domestic flights to major hubs. Accessible via I-64.",
      flightUrl: "https://www.flyphf.com/",
      flightLabel: "PHF Airport",
      featured: true,
    },
    {
      code: "ORF",
      name: "Norfolk International Airport",
      distance: "Approximately 45 miles southeast of Williamsburg",
      address: "2200 Norview Ave, Norfolk, VA 23518",
      note: "Major regional hub for southeastern Virginia. Accessible via I-64.",
      flightUrl: "https://www.norfolkairport.com/",
      flightLabel: "ORF Airport",
      featured: false,
    },
    {
      code: "RIC",
      name: "Richmond International Airport",
      distance: "Approximately 50 miles northwest of Williamsburg",
      address: "1 Richard E. Byrd Terminal Dr, Richmond, VA 23250",
      note: "Regional hub for Central Virginia. Accessible via I-64 W.",
      flightUrl: "https://www.flyrichmond.com/",
      flightLabel: "RIC Airport",
      featured: false,
    },
    {
      code: "IAD",
      name: "Dulles International Airport",
      distance: "Approximately 150 miles north of Williamsburg",
      address: "1 Saarinen Cir, Dulles, VA 20166",
      note: "Major international hub for the DC region. Accessible via I-64 W and I-95 N.",
      flightUrl: "https://www.flydulles.com/",
      flightLabel: "IAD Airport",
      featured: false,
    },
  ],
};